import { Components, Theme } from '@mui/material';

export const buildMuiAlertComponent = (): Components<Omit<Theme, 'components'>>['MuiAlert'] => ({
  styleOverrides: {
    root: ({ theme }) => ({
      padding: '21px',
      color: theme.palette.common.white,
      position: 'relative',
      '&.MuiAlert-filledError': {
        background: theme.palette.error.main,
      },
      '&.MuiAlert-filledSuccess': {
        background: theme.palette.success.main,
      },
      '&.MuiAlert-filledInfo': {
        background: theme.palette.info.main,
      },
      '&.MuiAlert-filledWarning': {
        background: theme.palette.warning.main,
      },
      '.MuiAlert-icon': {
        padding: '2px 0',
        svg: {
          fontSize: '20px',
        },
      },
      '.MuiAlert-message': {
        width: '100%',
        padding: '0',
        '.Custom-alert-title, .Custom-alert-description': {
          width: 'calc(100% - 57px)',
        },
      },
      '.MuiAlert-action': {
        padding: '2px 3px 0 16px',
        position: 'absolute',
        right: '26px',
        '.MuiIconButton-root': {
          padding: '0px',
          '> svg': {
            color: theme.palette.common.white,
          },
        },
      },
      '.Custom-alert-buttons': {
        display: 'flex',
        justifyContent: 'end',
        marginTop: '10px',
        '> div': {
          display: 'inherit',
        },
      },
    }),
  },
  defaultProps: {},
});
